import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const xMatters = defineConnector({
  identifier: "xMatters",
  name: "xMatters",
  tagLine: "Incident response and notifications",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: ({ url }) =>
    url ? `${url}/.*` : "https://example.xmatters.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create an OAuth access token",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://help.xmatters.com/xmapi/index.html](https://help.xmatters.com/xmapi/index.html) to create an OAuth access token for the xMatters REST API. xMatters documents `Authorization: Bearer <token>` and recommends it instead of storing HTTP Basic credentials in your application.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "url",
          label: "xMatters base URL",
          placeholder: "https://example.xmatters.com",
          required: true,
          target: { kind: "configuration", field: "url" },
        },
        {
          kind: "input",
          label: "OAuth access token",
          required: true,
          target: {
            kind: "secrets",
            field: "accessToken",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://example.xmatters.com/health",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod, ...configuration }) => ({
      url: testUrl ?? (({ url }) => `${url}/api/xm/1/people`)(configuration),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
